<!--
     <FieldLink>
-->

<template>
    <a :href="representation" target="_blank" :class="computed_class">{{ representation }}</a>
</template>
  
<script>
    export default {
     name: 'FielLink',
    
     props: ['field', 'disabled'],
    
     computed: {
       representation() {
         return '' + this.field.value;
       },

       computed_class() {
        if (this.disabled) {
          return "no_click"
        }
        return "";
       }
     },
    };
</script>